/* BetterSkin Luxe – theme.js */
(function () {
  'use strict';
  var TS = window.themeSettings || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {} };
  var S = TS.strings || {};

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function formatMoney(cents) {
    var fmt = TS.moneyFormat || '{{amount}} kr';
    cents = Number(cents) || 0;
    function num(dec, t, d) {
      var n = (cents / 100).toFixed(dec).split('.');
      return n[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (n[1] ? d + n[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        default: return num(2, ',', '.');
      }
    });
  }
  window.BSformatMoney = formatMoney;

  /* ---------- header: mobile menu, search, scroll state ---------- */
  var mnav = $('#MobileNav');
  function menu(open) {
    if (!mnav) return;
    mnav.classList.toggle('is-open', open);
    mnav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('scroll-lock', open);
    $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  $$('[data-menu-toggle]').forEach(function (b) { b.addEventListener('click', function () { menu(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu(false); }); });

  var search = $('#HeaderSearch');
  $$('[data-search-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!search) return;
      var open = search.hidden;
      search.hidden = !open;
      $$('[data-search-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) { var i = search.querySelector('input[type=search]'); if (i) i.focus(); }
    });
  });

  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3800);
  });

  /* ---------- reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    document.documentElement.classList.add('has-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, parseInt(input.value || '0', 10) + (plus ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart page auto update ---------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) {
    var ct;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(ct);
      ct = setTimeout(function () {
        var fd = new FormData(cartForm);
        fd.delete('checkout'); fd.delete('note');
        fetch(TS.routes.cart + '/update.js', { method: 'POST', body: fd })
          .then(function () { window.location.reload(); })
          .catch(function () { cartForm.submit(); });
      }, 450);
    });
  }

  /* ---------- collection sort ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- Sortimentet chips: scroll spy ---------- */
  var chips = $('[data-chips]');
  if (chips && 'IntersectionObserver' in window) {
    var groups = $$('[data-group]');
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        $$('[data-chip]', chips).forEach(function (c) {
          var on = c.getAttribute('data-chip') === en.target.id;
          c.classList.toggle('is-active', on);
          if (on && chips.scrollTo) chips.scrollTo({ left: c.offsetLeft - 20, behavior: 'smooth' });
        });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    groups.forEach(function (g) { spy.observe(g); });
  }

  /* ---------- before / after ---------- */
  $$('[data-ba]').forEach(function (ba) {
    var r = $('[data-ba-range]', ba);
    if (!r) return;
    var set = function () { ba.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', set); set();
  });

  /* ---------- countdown timer (cart) ---------- */
  (function () {
    var minutes = Number(TS.timerMinutes || 5);
    var KEY = 'bs_timer_end', end;
    try { end = Number(sessionStorage.getItem(KEY)); } catch (e) {}
    if (!end || isNaN(end) || end < Date.now() - 3600000) {
      end = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      $$('[data-timer]').forEach(function (el) { el.textContent = pad(Math.floor(left / 60)) + ':' + pad(left % 60); });
      if (left === 0) { $$('[data-cd-timer-wrap]').forEach(function (w) { w.hidden = true; }); clearInterval(iv); }
    }
    var iv = setInterval(tick, 1000); tick();
  })();

  /* ==========================================================
     Product page
     ========================================================== */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var section = root.closest('.pdp') || root.parentElement;
    var product = null;
    var jsonEl = section && section.querySelector('[data-product-json]');
    if (jsonEl) { try { product = JSON.parse(jsonEl.textContent); } catch (e) {} }

    /* Gallery */
    var gallery = $('[data-gallery]', root);
    var track = gallery && $('[data-gallery-track]', gallery);
    var slides = track ? $$('.gallery__slide', track) : [];
    var current = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function mark(i) {
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      var id = slides[i] && slides[i].dataset.mediaId;
      $$('[data-thumb]', gallery).forEach(function (t) {
        var on = t.dataset.thumb === id; t.classList.toggle('is-active', on);
        if (on && t.parentElement.scrollTo) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      });
      $$('[data-dot]', gallery).forEach(function (d) { d.classList.toggle('is-active', d.dataset.dot === id); });
    }
    function goTo(i, smooth) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function goToMedia(id) {
      var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(id); });
      if (i > -1) goTo(i);
    }
    if (track && slides.length) {
      if (current > 0) requestAnimationFrame(function () { goTo(current, false); });
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current && slides[i]) mark(i);
        }, 60);
      }, { passive: true });
      gallery.addEventListener('click', function (e) {
        var th = e.target.closest('[data-thumb]');
        if (th) { goToMedia(th.dataset.thumb); return; }
        if (e.target.closest('[data-gallery-prev]')) goTo(current - 1);
        if (e.target.closest('[data-gallery-next]')) goTo(current + 1);
      });
      window.addEventListener('resize', function () { goTo(current, false); });
    }

    /* Variant picker (optional block) */
    var picker = $('[data-variant-picker]', root);
    var idInputs = $$('[data-variant-id]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var badgeEl = $('[data-badge]', root);
    var stickyPrice = section && $('[data-sticky-price]', section);
    if (picker && product) {
      picker.addEventListener('change', function () {
        var opts = $$('.variant-picker', picker).map(function (fs) {
          var c = fs.querySelector('[data-option-input]:checked'); return c ? c.value : null;
        });
        $$('.variant-picker', picker).forEach(function (fs, i) { var l = fs.querySelector('[data-selected-value]'); if (l) l.textContent = opts[i] || ''; });
        var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) { if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = S.unavailable || ''; return; }
        idInputs.forEach(function (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); });
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.hidden = !sale; compareEl.textContent = sale ? formatMoney(v.compare_at_price) : ''; }
        if (badgeEl) { badgeEl.hidden = !sale; if (sale) badgeEl.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
        if (addBtn) { addBtn.disabled = !v.available; if (addLabel) addLabel.textContent = v.available ? addLabel.dataset.availableLabel : addLabel.dataset.soldoutLabel; }
        if (v.featured_media) goToMedia(v.featured_media.id);
        if (root.dataset.updateUrl === 'true' && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      });
    }

    /* Sticky buy bar */
    var bar = section && $('[data-sticky-atc]', section);
    var buyBox = $('.product-form', root) || addBtn;
    if (bar && buyBox && 'IntersectionObserver' in window) {
      var visible = true, past = false;
      var upd = function () {
        var show = !visible && past;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = $('[data-sticky-atc-btn]', bar); if (b) b.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; past = en[0].boundingClientRect.top < 0; upd(); }).observe(buyBox);
      $('[data-sticky-atc-btn]', bar).addEventListener('click', function () {
        // Use the real buy button so any Kaching bundle selection is respected
        if (addBtn && !addBtn.disabled) addBtn.click();
        else buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
  $$('[data-product-section]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-product-section]', e.target).forEach(initProduct); });

  /* ==========================================================
     Add to cart (works with Kaching Bundles)
     ========================================================== */
  var internal = 0;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (TS.cartType !== 'drawer' || !window.BSCart || !window.BSCart.enabled()) return; // native submit → cart page
    // If another script (e.g. Kaching) already handled the submit, stay out of the way.
    if (e.defaultPrevented) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (err) err.hidden = true;
    internal++;
    fetch(TS.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || S.error); return j; }); })
      .then(function () { window.BSCart.open(); })
      .catch(function (ex) { if (err) { err.textContent = ex.message || S.error; err.hidden = false; } else { form.submit(); } })
      .finally(function () { internal--; if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });

  /* Open the drawer when an app (e.g. Kaching) adds to cart with its own request */
  var openTimer;
  function appAdded() { clearTimeout(openTimer); openTimer = setTimeout(function () { if (window.BSCart) { window.BSCart.enabled() ? window.BSCart.open() : window.BSCart.refresh(); } }, 150); }
  function isAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }
  function isChange(url) { return typeof url === 'string' && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url); }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (!internal && (isAdd(url) || isChange(url))) {
        p.then(function (r) { if (r && r.ok) { if (isAdd(url)) appAdded(); else if (window.BSCart) window.BSCart.count(); } }).catch(function () {});
      }
      return p;
    };
  }
  (function () {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      this._bsUrl = url;
      this.addEventListener('load', function () { if (!internal && this.status >= 200 && this.status < 300 && isAdd(String(this._bsUrl))) appAdded(); });
      return open.apply(this, arguments);
    };
  })();

  /* ==========================================================
     Cart drawer
     ========================================================== */
  var drawer = $('[data-cart-drawer]');
  function getCart() { return fetch(TS.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; if (n > 0) el.removeAttribute('data-empty'); else el.setAttribute('data-empty', ''); });
  }
  window.BSCart = {
    enabled: function () { return !!drawer; },
    open: function () { if (!drawer) { window.location.href = TS.routes.cart; return; } render(); show(true); },
    refresh: function () { return drawer ? render() : getCart().then(function (c) { setCount(c.item_count); }); },
    count: function () { getCart().then(function (c) { setCount(c.item_count); }); }
  };
  document.addEventListener('cart:refresh', function () { window.BSCart.refresh(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) window.BSCart.count(); });
  if (!drawer) return;

  var panel = $('.cart-drawer__panel', drawer);
  var body = $('[data-cd-body]', drawer);
  var foot = $('[data-cd-foot]', drawer);
  var lastFocus = null;
  function show(on) {
    drawer.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('scroll-lock', on);
    if (on) { lastFocus = document.activeElement; setTimeout(function () { panel.focus(); }, 60); }
    else if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function post(path, data) {
    internal++;
    return fetch(TS.routes.cart + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json(); }).finally(function () { internal--; });
  }
  function render() {
    body.classList.add('is-busy');
    return getCart().then(function (cart) {
      body.classList.remove('is-busy');
      setCount(cart.item_count);
      $('[data-cd-count]', drawer).textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>' + esc(S.empty) + '</p><a class="btn btn--primary" href="' + esc(TS.emptyUrl || '/collections/all') + '">' + esc(S.shopNow) + '</a></div>';
        foot.hidden = true; return;
      }
      foot.hidden = false;
      var html = '';
      cart.items.slice().sort(function (a, b) { return (a.final_line_price === 0) - (b.final_line_price === 0); }).forEach(function (it) {
        var free = it.final_line_price === 0;
        var strike = it.original_line_price > it.final_line_price;
        var props = '';
        if (it.properties) Object.keys(it.properties).forEach(function (k) { var v = it.properties[k]; if (k.charAt(0) !== '_' && v) props += '<p class="cd-line__meta">' + esc(k) + ': ' + esc(v) + '</p>'; });
        html += '<div class="cd-line' + (free ? ' cd-line--free' : '') + '">' +
          '<a class="cd-line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
          '<div class="cd-line__info">' +
            '<a class="cd-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title && !it.product_has_only_default_variant && !it.gift_card ? '<p class="cd-line__meta">' + esc(it.variant_title) + '</p>' : '') + props +
            '<div class="cd-line__row">' +
              '<div class="qty qty--sm"><button type="button" data-cd-change="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="' + esc(S.decrease) + '">−</button><span>' + it.quantity + '</span><button type="button" data-cd-change="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="' + esc(S.increase) + '">+</button></div>' +
              '<button type="button" class="cd-line__remove" data-cd-change="' + esc(it.key) + '" data-q="0">' + esc(S.remove) + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-line__price">' + (strike ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') +
            (free ? '<strong class="cd-free">' + esc(S.free) + '</strong>' : '<strong>' + formatMoney(it.final_line_price) + '</strong>') + '</div>' +
        '</div>';
      });
      body.innerHTML = html;
      var saved = Math.max(0, cart.original_total_price - cart.total_price);
      $('[data-cd-save-row]', drawer).hidden = saved <= 0;
      $('[data-cd-save]', drawer).textContent = '−' + formatMoney(saved);
      $('[data-cd-total]', drawer).textContent = formatMoney(cart.total_price);
    }).catch(function () { body.classList.remove('is-busy'); });
  }
  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { show(false); return; }
    var ch = e.target.closest('[data-cd-change]');
    if (ch) {
      body.classList.add('is-busy');
      post('/change.js', { id: ch.getAttribute('data-cd-change'), quantity: Math.max(0, Number(ch.getAttribute('data-q'))) }).then(render, render);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (drawer.classList.contains('is-open')) show(false); menu(false); } });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cart-link]');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); window.BSCart.open(); }
  });
})();

/* ==========================================================
   Shade bundle offer – quantity tiers with one shade per unit
   ========================================================== */
(function () {
  'use strict';
  var TS = window.themeSettings || { routes: { cart: '/cart', cartAdd: '/cart/add' } };
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(c) { return window.BSformatMoney ? window.BSformatMoney(c) : Math.round(c / 100) + ' kr'; }
  function moneyShort(c) { return money(c).replace(/[.,]00(?=\D|$)/, ''); }

  function init(offer) {
    if (offer.dataset.ready) return; offer.dataset.ready = '1';
    var root = offer.closest('[data-product-section]') || document;
    var tiers = $$('[data-tier]', offer);
    var summary = offer.querySelector('[data-bundle-summary]');
    var label = root.querySelector('[data-add-label]');
    var baseLabel = offer.dataset.buttonLabel || (label && label.dataset.availableLabel) || '';

    function current() { return tiers.filter(function (t) { return t.classList.contains('is-selected'); })[0] || tiers[0]; }
    function rows(tier) { return $$('[data-shade-row]', tier); }
    function checked(row) { return row.querySelector('input[type=radio]:checked'); }
    function setRow(row, value) {
      var inp = row.querySelector('input[value="' + value + '"]');
      if (inp && !inp.disabled) inp.checked = true;
      nameRow(row);
    }
    function nameRow(row) {
      var c = checked(row), n = row.querySelector('[data-shade-name]');
      if (n && c) n.textContent = c.dataset.shade;
    }
    function selection(tier) {
      return rows(tier).map(function (r) { var c = checked(r); return c ? { id: c.value, name: c.dataset.shade } : null; }).filter(Boolean);
    }
    function update() {
      var tier = current(); if (!tier) return;
      var sel = selection(tier), counts = {}, order = [];
      sel.forEach(function (s) { if (!counts[s.name]) { counts[s.name] = 0; order.push(s.name); } counts[s.name]++; });
      if (summary) {
        var txt = order.map(function (n) { return '<strong>' + counts[n] + '× ' + n + '</strong>'; }).join(', ');
        var gift = offer.dataset.giftVariant ? ' <span class="offer__summary-gift">+ presentkort</span>' : '';
        summary.innerHTML = txt ? 'Din beställning: ' + txt + gift : '';
      }
      if (label && baseLabel) {
        var t = baseLabel + ' · ' + moneyShort(Number(tier.dataset.price));
        label.textContent = t; label.dataset.availableLabel = t;
      }
    }
    function select(tier) {
      var prev = current();
      if (prev === tier) return;
      var prevSel = prev ? selection(prev) : [];
      tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); var r = t.querySelector('input[name$="-tier"]'); if (r) r.checked = t === tier; });
      // carry the chosen shades over to the new tier
      rows(tier).forEach(function (row, i) {
        if (prevSel[i]) setRow(row, prevSel[i].id);
      });
      update();
    }

    offer.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name && /-tier$/.test(t.name)) { select(t.closest('[data-tier]')); return; }
      var row = t.closest('[data-shade-row]');
      if (!row) return;
      var tier = row.closest('[data-tier]');
      if (tier !== current()) select(tier);
      nameRow(row);
      row.classList.remove('is-pop'); void row.offsetWidth; row.classList.add('is-pop');
      update();
    });
    // clicking anywhere on a tier card selects it
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) { if (!e.target.closest('input, label.swatch')) select(tier); });
    });
    rows(offer).forEach(nameRow);
    update();

    offer._bsItems = function () {
      var tier = current();
      var ids = selection(tier).map(function (s) { return s.id; });
      if (!ids.length) {
        var idInput = root.querySelector('[data-variant-id]');
        var q = Number(tier.dataset.qty) || 1;
        for (var i = 0; i < q; i++) if (idInput) ids.push(idInput.value);
      }
      var map = {}, items = [];
      ids.forEach(function (id) { map[id] = (map[id] || 0) + 1; });
      Object.keys(map).forEach(function (id) { items.push({ id: Number(id), quantity: map[id] }); });
      return items;
    };
  }

  // Capture phase: runs before the theme's own submit handler and before app scripts on the form.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var root = form.closest('[data-product-section]');
    var offer = root && root.querySelector('[data-bundle]');
    if (!offer || !offer._bsItems) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-form-error]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (err) err.hidden = true;
    var items = offer._bsItems();
    var giftId = Number(offer.dataset.giftVariant || 0);
    var cartUrl = TS.routes.cart + '.js';
    fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
      .then(function (cart) {
        var hasGift = (cart.items || []).some(function (it) { return it.variant_id === giftId && it.properties && it.properties._bs_gift; });
        if (giftId && !hasGift) items.push({ id: giftId, quantity: 1, properties: { _bs_gift: '1' } });
        return fetch(TS.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Något gick fel'); return j; }); })
      .then(function () {
        if (window.BSCart && window.BSCart.enabled()) window.BSCart.open();
        else window.location.href = TS.routes.cart;
      })
      .catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }, true);

  function boot(scope) { $$('[data-bundle]', scope).forEach(init); }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
